import { useBusinessContext } from '@context'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaTrash } from 'react-icons/fa'
import { ActivateEInvoicing } from './ActivateEInvoicing'
import { EInvoicingDetails } from './EInvoicingDetails'
import { useDisableEinvoicing } from '@root/query/hooks'
import { SettingsSubPageLayout } from '@pages/SettingsPage/components/SettingsSubPageLayout'

export const EInvoicingSettings: React.FC = () => {
  const { data: business } = useBusinessContext()
  const [t] = useTranslation()

  const { mutate: disableEinvoicingMutation, isPending: isDisabling } = useDisableEinvoicing()

  return (
    <SettingsSubPageLayout
      title={t('settings.einvoicing.header')}
      menuItems={
        business?.einvoicing_enabled
          ? [
              {
                Icon: FaTrash,
                name: t('settings.einvoicing.disable'),
                onClick: () => disableEinvoicingMutation(),
                intent: 'danger',
                disabled: isDisabling
              }
            ]
          : null
      }
    >
      {business.einvoicing_enabled ? <EInvoicingDetails /> : <ActivateEInvoicing />}
    </SettingsSubPageLayout>
  )
}
